import { useEffect } from 'react';

import { usePlayerStoreApi } from '@cartwhl/3d/player';

import { useStore as useKeyPoseStore } from '../keyPoseStore';

const GENERATION_AUTO_FIT_SUPPRESSION_MS = 10_000;
const POST_GENERATION_AUTO_FIT_SUPPRESSION_MS = 5_000;

/**
 * Keeps the camera pose stable while key-pose regeneration reloads scene motion.
 */
export function useKeyPoseGenerationCameraPreserve() {
  const keyPoseStore = useKeyPoseStore();
  const playerStore = usePlayerStoreApi();
  const isGenerating = keyPoseStore.state.generation.status === 'pending';

  useEffect(() => {
    if (!isGenerating) {
      return;
    }

    playerStore.suppressCharacterAutoFitAfterGizmo(
      GENERATION_AUTO_FIT_SUPPRESSION_MS,
    );

    const intervalId = window.setInterval(() => {
      playerStore.suppressCharacterAutoFitAfterGizmo(
        GENERATION_AUTO_FIT_SUPPRESSION_MS,
      );
    }, 2_000);

    return () => {
      window.clearInterval(intervalId);
      playerStore.suppressCharacterAutoFitAfterGizmo(
        POST_GENERATION_AUTO_FIT_SUPPRESSION_MS,
      );
    };
  }, [isGenerating, playerStore]);
}
